import React from "react";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";
import "components/Layout/style.css";
import { FormHelperText } from "@mui/material";

const RadioButton = ({
  handleChange,
  value,
  options,
  formTitle,
  radioButtonClass,
  className,
  name = "",
  error = false,
  errorMessage = "",
  isFarm=false,
}) => {
  return (
    <FormControl fullWidth className={className} error={error}>
      <FormLabel
        id="demo-row-radio-buttons-group-label"
        className="form-label"
      >
        {formTitle}
      </FormLabel>
      <RadioGroup
        row
        aria-labelledby="demo-row-radio-buttons-group-label"
        name={name}
        className={radioButtonClass}
        value={value}
        onChange={handleChange}
      >
        {options?.map((option) => (
          <>
            <FormControlLabel
              value={isFarm? option?.id: option.value}
              control={<Radio />}
              label={isFarm? option?.name: option.label}
            />
          </>
        ))}
      </RadioGroup>
      <FormHelperText>{errorMessage}</FormHelperText>
    </FormControl>
  );
};

export default RadioButton;
